import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { DatalistviewComponent } from 'src/app/shared/datalistview/datalistview.component';
import { DataListFilterColumn, Datalistviewcolumn } from 'src/app/shared/datalistview/columns/datalistviewcolumn';
import { Busyable } from 'src/app/shared/editors/busyable';

@Component({
    selector: 'app-reportslist',
    templateUrl: './reportslist.component.html',
    styleUrls: ['./reportslist.component.scss'],
    standalone: false
})
export class ReportslistComponent extends Busyable {
  public Columns: Array<Datalistviewcolumn> = [
    new DataListFilterColumn('Name', 'Name', true, 'Name'),
    new DataListFilterColumn('Category', 'Category', true, 'Category'),
    new Datalistviewcolumn('Description', 'Description', 80)
  ];

  @ViewChild(DatalistviewComponent)
  public DataList?: DatalistviewComponent;

  constructor(
    private router: Router) {
    super();
  }

  public OpenReport(report: any) {
    this.router.navigate(['/reports/run', report.Id]);
  }
}
